<div class="chart" echarts [options]="options" *ngIf="data && data.points?.length && !sparse && !allZero"></div>
<!-- allZero is a real reading, not missing data, so it states the fact rather than borrowing
     the insufficient-data copy (that exact conflation shipped a bug on the capacity chart). -->
<div class="trend-sparse" *ngIf="data && data.points?.length && (sparse || allZero)">
  <span class="ts-val" *ngIf="currentValue !== null">{{ currentValue }}%</span>
  <span class="ts-msg">{{ (allZero ? 'dashboard.company.trend_all_zero' : 'dashboard.company.trend_insufficient') | translate }}</span>
</div>
